<div class="modal-header">
    <button type="button" id="js-btn-close" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Wert schreiben"}}</h4>
</div>

<div class="modal-body">
    {{!-- value configuration --}}
    <div class="row m-t-10 js-hide-while-writing" id="js-selectpickersRow">
        <div class="col-sm-6">
            {{#SELECT selectedCategoryID}}
            <select
                id="js-category-select"
                class="selectpicker"
                data-live-search="true"
                data-style="btn-white"
                data-title="{{TR 'Gerätetyp auswählen'}}">
                {{#each categories}}
                    <option value="{{name}}">{{TYPE_DEVICE category type}} ({{deviceCount}}
                    {{#COMPARE deviceCount '==' 1}}{{TR 'Gerät'}}{{else}}{{TR 'Geräte'}}{{/COMPARE}})
                    </option>
                {{/each}}
            </select>
            {{/SELECT}}
        </div>
        <div class="col-sm-6">
            {{#SELECT selectedValueID}}
            <select
                id="js-value-select"
                class="selectpicker"
                {{#unless selectedCategoryID}} disabled{{/unless}}
                {{#unless values}} disabled{{/unless}}
                data-live-search="true"
                data-style="btn-white"
                data-title="{{TR 'Wert auswählen'}}">
                {{#each values}}
                <optgroup label="{{TR name}}">
                {{#each items}}
                    <option value="{{id}}">{{TR_DATAPOINT_CATEGORY ../../selectedCategoryID name}}</option>
                {{/each}}
                </optgroup>
                {{/each}}
            </select>
            {{/SELECT}}
        </div>
    </div>
    <div id="dataInput" class="js-hide-while-writing">
        <div class="alert alert-info m-t-20">
        {{#if selectedCategoryID}}
            {{#unless values}}
                {{TR "Keine beschreibbaren Werte verfügbar."}}
            {{else}}
                {{TR "Kein Wert ausgewählt."}}
            {{/unless}}
        {{else}}
            {{TR "Kein Gerätetyp ausgewählt."}}
        {{/if}}
        </div>
    </div>

    {{!-- label configuration --}}
    <div class="row js-hide-while-writing ">
        <div class="col-sm-12">
            <div class="checkbox checkbox-primary">
                <input
                    class="js-checkbox-adv"
                    id="cb-labels"
                    name="js-labels"
                    type="checkbox"
                    {{#if showLabels}}checked="checked"{{/if}}
                >
                <label for="cb-labels"><strong>{{TR "Geräte nach Schreibvorgang mit Label kennzeichnen"}}</strong></label>
            </div>
        </div>
    </div>
    <div id="js-cb-label-content" class="row m-b-20 js-hide-while-writing " style="display: none">
        <div class="col-sm-6">
            <input
                class="form-control js-input js-label"
                id="js-label-success"
                type="text"
                value="{{labelSuccess}}"
                placeholder="{{TR "Label bei Erfolg"}}"
            />
        </div>
        <div class="col-sm-6">
            <input
                class="form-control js-input js-label"
                id="js-label-fail"
                type="text"
                value="{{labelFail}}"
                placeholder="{{TR "Label bei Fehler"}}"
            />
        </div>
    </div>

    {{!-- child view --}}
    <div id="progressInfo"></div>
</div>

<div class="modal-footer">
    <button id="js-btn-cancel" class="btn btn-white" data-dismiss="modal">
        {{TR "Schließen"}}
    </button>
    <button id="js-btn-write" class="btn btn-primary"{{#unless selectedValueID}} disabled{{/unless}}>
        {{TR "Schreiben"}}
    </button>
</div>
